module.exports = __webpack_public_path__ + "static/img/first.9024f842.png";